import React, { useState, useEffect } from "react";
import ChangeLogBlock from "./change-log-block/change-log-block";
import PaginatorContainer from "items/paginator/paginator-container";
import s from "./about-system.module.scss";

const AboutSystem = (props) => {
    const [changeLogs, setChangeLogs] = useState(props.changeLogs);

    const changeLogsBlocks = changeLogs ? Object.keys(changeLogs).map((k, i) => <ChangeLogBlock key={i} {...changeLogs[k]} getValue={props.getValue}/>) : null;

    useEffect(() => {
        setChangeLogs(props.changeLogs);
    }, [props]);

    return (
        <div className={s.AboutSystem}>
            <PaginatorContainer />
            {changeLogsBlocks}
        </div>
    )
}

export default AboutSystem;